import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import Tooltip from './tooltip';

class AppSidebarExpand extends PureComponent {
    handleClick = () => {
        this.props.dispatch({ type: 'SIDEBAR_EXPAND_REQUESTED' });
    }

    render() {
        const { t } = this.props;
        return null;

        if (this.props.sidebarExpanded) {
        }

        return (
            <Tooltip tooltip={t('Expand')}>
                <button className={'btn btn-sidebar-expand' + (this.props.absolute ? ' absolute' : '')} onClick={this.handleClick}><i className="icon material-icons">menu</i></button>
            </Tooltip>
        )
    }
}

const makeMapStateToProps = () => {
    return ({ sidebar }) => ({
        sidebarExpanded: sidebar.expanded
    })
}

export default connect(makeMapStateToProps)(withTranslation('sidebar')(AppSidebarExpand));
